import styled from 'styled-components';
import { WarningBadge } from 'ui/badge';
import { SecondaryButton } from 'ui/button';
import { OpenNewWindow16 } from 'ui/icons';
import { RadioList } from 'ui/radioList';
import { Subtitle2, colors, fontSizes, fontWeights, spacing, textColors } from 'ui/theme';
import { Toggle } from 'ui/toggle';

export const GroupLabel = styled.div`
  margin-bottom: ${spacing.plusHalf};
`;

export const OptionButton = styled(SecondaryButton)<{ isSelected?: boolean }>`
  && {
    border: ${({ isSelected }) =>
      isSelected ? `${spacing.eighth} solid ${colors.purple50}` : 'none'};
    background-color: ${colors.backgroundSecondary};
    box-shadow: none;
  }
  height: ${spacing.x4};
  width: 100%;
  margin-bottom: ${spacing.threeQuarter};
`;

export const OptionContent = styled.div`
  width: 100%;
  font-size: ${fontSizes.s14};
`;

export const Label = styled.label`
  margin-bottom: 0;
`;

export const Name = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${spacing.half};
  margin-bottom: ${spacing.quarter};
  color: ${textColors.textPrimary};
`;

export const Description = styled.p`
  font-size: ${fontSizes.s12};
  font-weight: ${fontWeights.regular};
  color: ${textColors.textSecondary};
  text-align: left;
`;

export const LearnMoreLink = styled.a`
  display: inline-flex;
  position: relative;
  gap: ${spacing.eighth};
  margin-left: ${spacing.quarter};
`;

export const LinkContent = styled.span<{ color?: string; isUnderlined?: boolean }>`
  ${({ isUnderlined }) => (isUnderlined ? `text-decoration: underline;` : '')}
  color: ${({ color }) => color || textColors.textLink};
  cursor: pointer;
`;

export const StyledOpenWindowIcon = styled(OpenNewWindow16)`
  position: relative;
  top: ${spacing.eighth};
  height: ${spacing.threeQuarter};
`;

export const TextInputRow = styled.div`
  display: flex;
  gap: ${spacing.half};
  width: 100%;
  margin-top: ${spacing.plusHalf};

  > div {
    flex-grow: 1;
    margin-top: unset !important;
  }
`;

export const StyledWarningBadge = styled(WarningBadge)`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: ${spacing.half};
  padding: ${spacing.base};
  color: ${colors.warning100};
  background-color: ${colors.salmon10};
  margin-top: ${spacing.plusHalf};

  p {
    font-size: ${fontSizes.s12};
    font-weight: ${fontWeights.light};
    margin-top: ${spacing.quarter};
  }
`;

export const ToggleRow = styled.div`
  display: flex;
  position: relative;
  gap: ${spacing.half};
  align-items: center;

  .RGItemContainer {
    align-items: flex-start;
  }
`;

export const StyledFileUpload = styled.input`
  display: none !important;
`;

export const StyledFileUploadField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing.half};
  position: relative;
  border: ${spacing.single} solid ${colors.grey15};
  border-radius: ${spacing.threeEights};
  padding: ${spacing.plusHalf};
  background-color: ${colors.grey1};
`;

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: ${colors.grey10};
  opacity: 0.5;
`;

export const ErrorMessage = styled.span`
  font-size: ${fontSizes.s12};
  color: ${colors.textDestructive};
`;

export const StyledLabel = styled(Subtitle2)`
  margin: 0;
`;

export const StyledInputFieldContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.threeQuarter};
  width: 100%;
`;

export const StyledToggle = styled(Toggle)`
  align-self: center;
  position: relative;
  top: -${spacing.quarter};
`;

export const StyledRadioList = styled(RadioList)`
  * {
    margin-bottom: 0;
  }

  > span {
    font-weight: ${fontWeights.semiBold};
  }
`;
